__turbopack_context__.v({
  "bannerItem": "DesktopCarouselBanner-module__ydQLAG__bannerItem",
  "bannerWrapper": "DesktopCarouselBanner-module__ydQLAG__bannerWrapper",
  "divider": "DesktopCarouselBanner-module__ydQLAG__divider",
});
